import { HttpConstants } from "../../protocols/http/http-constants";
import { DeleteTourProgram } from "../../../domain/useages/monthly-tour-program/deleteTourProgram";
import { HttpDeleteClient } from "../../protocols/http/http-delete-client";

export class RemoteDeleteTourProgram
  implements DeleteTourProgram
{
  constructor(
    private readonly url: string,
    private readonly httpDeleteClient: HttpDeleteClient
  ) {}

  async delete(
    id: string,
  ): Promise<any> {
    const httpResponse = await this.httpDeleteClient.delete({
      url: this.url.replace(":id", id),
      headers: {
              [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
              [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
               [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
            },
      authHeaders: true,
    });

    if (httpResponse.status === 204) {     
      
    }
  }
}
